import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
//import Table from "components/Table/Table.js";
import CustomButton from "components/CustomButtons/Button"
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardIcon from "components/Card/CardIcon.js";
import ThermostatIcon from '@mui/icons-material/Thermostat';
import CustomAreaChart from "components/CustomAreaChart/CustomAreaChart";
import PredictionAreaChart from "components/PredictionAreaChart/PredictionAreaChart";
import Swal from 'sweetalert2';

import LocalDrinkIcon from '@mui/icons-material/LocalDrink';
import AutoGraphIcon from '@mui/icons-material/AutoGraph';
import BoltIcon from '@mui/icons-material/Bolt';
import ScienceIcon from '@mui/icons-material/Science';
import BiotechIcon from '@mui/icons-material/Biotech';
import FitbitIcon from '@mui/icons-material/Fitbit';

import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner'
import CustomLineChartNPK from "components/CustomLineChart/CustomLineChartNPK";

import Select from 'react-select';
//import {RangePicker} from 'react-minimal-datetime-range';
import 'react-minimal-datetime-range/lib/react-minimal-datetime-range.min.css';

import { useSelector } from 'react-redux';
import { useState, useEffect} from "react";
import { useDispatch } from 'react-redux';
import { dataActions } from '../../store/data-slice'


import { fetchConToken } from "helpers/fetch";
import { getSensors, getSensorsStr, mapSensorsList, mapSelectedSensorsStr, transformDateRange } from "helpers/sensors";
import { MultiSelect } from "components/MultiSelect/MultiSelect";


import { DatePicker } from 'antd';



import styles from "assets/jss/material-dashboard-react/views/dashboardStyle.js";
import "react-minimal-datetime-range/lib/react-minimal-datetime-range.min.css";
import 'antd/dist/antd.css';
import moment from 'moment';

import './styles.css';

import { setDateHistoricos } from '../../store/data-actions';



/* const styles = {
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0",
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF",
    },
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1",
    },
  },
}; */

const useStyles = makeStyles(styles);



const now = new Date();
/* const todayY = now.getFullYear();
const todayM = now.getMonth() + 1;
const todayD = now.getDate(); */


const { RangePicker } = DatePicker;



const metricas_options = [
  { value: "mean_soil_temp", label: "Temperatura S" },
  { value: "mean_soil_moist", label: "Humedad S" },
  { value: "mean_ph", label: "PH" },
  { value: "mean_ec", label: "Conductividad Eléctrica" },
  { value: "mean_n", label: "Nitrogeno (N)" },
  { value: "mean_p", label: "Fósforo (P)" },
  { value: "mean_k", label: "Potasio (K)" },
  { value: "mean_voltage", label: "Batería" }
];
/* const sensores_options = [
  { value: "1", label: "Jimmy" },
  { value: "2", label: "Laura" },
  { value: "3", label: "Tommy" },
  { value: "4", label: "Jane" },
  { value: "5", label: "Mike" }
]; */

const translations = {
  en: {
    lSoilTemp: "Soil Temperature",
    lSoilMoist: "Soil Moisture",
    lPh: "PH",
    lEc: "Electrical Conductivity (EC)",
    lN: "Nitrogen (N)",
    lP: "Phosphorus (P)",
    lK: "Potasium (K)",
    lBattery: "Battery Load",
  },
  es: {
    lSoilTemp: "Temperatura del Suelo",
    lSoilMoist: "Humedad del Suelo",
    lPh: "PH",
    lEc: "Conductividad Eléctrica (EC)",
    lN: "Nitrógeno (N)",
    lP: "Fósforo (P)",
    lK: "Potasio (K)",
    lBattery: "Carga de Batería",
    
    
  }
};

export default function Predicciones() {
  const classes = useStyles();
  const dispatch = useDispatch();

  const {language} = useSelector( state => state.data); 
  const t = translations[language];

  // const [selectedMetricasOption, setSelectedMetricasOption] = useState(null);
  const [selectedMetricas, setSelectedMetricas] = useState([]);
  const [selectedSensors, setSelectedSensors] = useState([]);
  const [selectedDateRange, setSelectedDateRange] = useState(["-5d","now()"]);
  const [loading, setLoading] = useState(true);
  const [selectedSensorsStr, setSelectedSensorsStr] = useState("");

  const { checking } = useSelector( state => state.auth);
  const { allPlantaciones, indexPlantacion, plantaciones, listaSensoresHistoricos, selectedSensorsMulti, selectedMetricasMulti, startDate, endDate } = useSelector( state => state.data);
  
  //let [sensors, setSensors] = useState(["65d993f557cacc29"]);

  //let sensors = ["65d993f557cacc29"]; //moved to MapSensor List
  let sensors = getSensors(plantaciones, allPlantaciones, indexPlantacion);
  let sensorStr = getSensorsStr(sensors);
  

  //setSelectedSensorsStr(sensorStr);
  
  
  //const { start, query, sensors, fillcolor, strokecolor } = props;

  let [voltage_average, setVoltageAverage] = useState("");
  let [ec_average, setEcAverage] = useState("");
  let [ph_average, setPhAverage] = useState("");
  let [N_average, setNAverage] = useState("");
  let [P_average, setPAverage] = useState("");
  let [K_average, setKAverage] = useState("");
  let [soil_temp_average, setSoilTempAverage] = useState("");
  let [soil_moist_average, setSoilMoistAverage] = useState("");
  //let [data2, setData2] = useState([]);

 

  useEffect(() => {
    let mounted = true;
    
    setLoading(true);

    sensors = [];
    sensors = getSensors(plantaciones, allPlantaciones, indexPlantacion);
    sensorStr = getSensorsStr(sensors);
  
  
    //inicia con todos los sensores seleccionados, averiguar como hacer el multiselect que escoga todos delsde el inicio
    setSelectedSensorsStr(sensorStr);
    setSelectedSensors(sensors);
    setSelectedMetricas(metricas_options);

    console.log('SensorList:', JSON.stringify(mapSensorsList(plantaciones, allPlantaciones, indexPlantacion)) );


    dispatch(dataActions.sensoresHistoricos({
      listaSensoresHistoricos: mapSensorsList(plantaciones, allPlantaciones, indexPlantacion),
    }))

    //inicia con todas la metricas seleccionados, averiguar como hacer el multiselect que escoga todos delsde el inicio
    dispatch(dataActions.filtrosMetricasHistoricos({
      selectedMetricasMulti: metricas_options,
    }))
    dispatch(dataActions.filtrosSensoresHistoricos({
      selectedSensorsMulti: selectedSensors,
    }))


    //query all averages for each card near real-time measure
    
    
   console.log("SensorStr in useEffect Hist:" + sensorStr);
   setLoading(false);
    

    return () => mounted = false;
  }, [indexPlantacion, allPlantaciones, ])

  if ( loading ) {
     
    return (
        <div style={{padding: '10px', width: '80px', height: '80px'}}>
            <LoadingSpinner />
        </div>
        );
  }
  
  
  return (
    <>
    
    <GridContainer>

     
          <GridItem xs={12} sm={12} md={12}>
            <Card>
            <CardHeader color="warning" stats icon>
                  <CardIcon color="warning">
                    <ThermostatIcon />
                    {/* <Icon>content_copy</Icon> */}
                    {/* <Icon baseClassName="fas" className="fa-solid fa-temperature-high" /> */}
                    {/* <FontAwesomeIcon icon="fa-solid fa-temperature-high" /> */}
    
                  </CardIcon>
                  <p className={classes.cardCategory} style={{fontSize: '21px', marginTop:'5px'}}>{t.lSoilTemp}&nbsp; </p>
                  {/* <h2 className={classes.cardTitle} style={{fontSize: '25px', display:'inline'}}>
                  {soil_temp_average} <small>°C</small> 
                  </h2> */}
              </CardHeader>
          
              <CardBody style={{ padding:'3px', marginLeft:'3px', minHeight:'200px'}}>
                {/* <ThermostatIcon />
                <p className={classes.cardCategory} style={{fontSize: '21px', display:'inline'}}>Temperatura del Suelo : &nbsp; </p>
                <h2 className={classes.cardTitle} style={{fontSize: '25px', display:'inline'}}>
                  {soil_temp_average} <small>°C</small> 
                </h2> */}
                <PredictionAreaChart query="mean_soil_temp" sensors={selectedSensorsStr} strokecolor='#DD7B13' fillcolor='#FE952D' units='°C' factor={1000} listaSensoresHistoricos={listaSensoresHistoricos}  />
                
              </CardBody>
              
              {/* <CardFooter chart style={{flexDirection:'column', padding:'2px', marginLeft:'1px', height:'100px'}}>
                  
              </CardFooter> */}
    
            </Card>
          </GridItem>

        

      



 

        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="success" stats icon>
                <CardIcon color="success">
                
                  <LocalDrinkIcon />
                </CardIcon>
                <p className={classes.cardCategory} style={{fontSize: '21px', marginTop:'5px'}}>{t.lSoilMoist}&nbsp;</p>
                {/* <h2 className={classes.cardTitle} style={{fontSize: '25px', display:'inline'}}>
                  {soil_moist_average} <small>%</small> 
                </h2> */}
            </CardHeader>
        
            <CardBody  style={{ padding:'3px', marginLeft:'3px', minHeight:'200px'}}>
              {/* <CustomAreaChart key={selectedSensorsStr} start={startDate} stop={endDate} query="mean_soil_moist" sensors={selectedSensorsStr} strokecolor='#29B24F' fillcolor='#2FD15C' units='%' factor={1000} /> */}
              <PredictionAreaChart query="mean_soil_moist" sensors={selectedSensorsStr} strokecolor='#29B24F' fillcolor='#2FD15C' units='%' factor={1000} listaSensoresHistoricos={listaSensoresHistoricos}  />
              
          </CardBody>
            
            {/* <CardFooter chart style={{flexDirection:'column', padding:'2px', marginLeft:'1px', height:'100px'}}>
                
            </CardFooter> */}

          </Card>
        </GridItem>
    
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="danger" stats icon>
                <CardIcon color="danger">
                  <AutoGraphIcon />
                </CardIcon>
                <p className={classes.cardCategory} style={{fontSize: '21px', marginTop:'5px'}}>{t.lPh}&nbsp;</p>
                {/* <h2 className={classes.cardTitle} style={{fontSize: '25px', display:'inline'}}>
                  {ph_average} 
                </h2> */}
            </CardHeader>
        
            <CardBody  style={{ padding:'3px', marginLeft:'3px', minHeight:'200px'}}>
              {/* <CustomAreaChart start={startDate} stop={endDate} query="mean_ph" sensors={selectedSensorsStr} strokecolor='#AF1F1F' fillcolor='#E02D2D' units='pH' factor={100} /> */}
              <PredictionAreaChart  query="mean_ph" sensors={selectedSensorsStr} strokecolor='#AF1F1F' fillcolor='#E02D2D' units='pH' factor={100} listaSensoresHistoricos={listaSensoresHistoricos}  />
              
            </CardBody>
            
            {/* <CardFooter chart style={{flexDirection:'column', padding:'2px', marginLeft:'1px', height:'100px'}}>
                
            </CardFooter> */}

          </Card>
        </GridItem>
      

        <GridItem xs={12} sm={12} md={12}>
          <Card>
          <CardHeader color="info" stats icon>
                <CardIcon color="info">
                  <BoltIcon />
                </CardIcon>
                <p className={classes.cardCategory} style={{fontSize: '21px', marginTop:'5px'}}>{t.lEc}&nbsp;</p>
                {/* <h2 className={classes.cardTitle} style={{fontSize: '25px', display:'inline'}}>
                  {ec_average} <small>mS/m</small>
                </h2> */}
              </CardHeader>
        
            <CardBody  style={{ padding:'3px', marginLeft:'3px', minHeight:'200px'}}>
              {/* <CustomAreaChart start={startDate} stop={endDate} query="mean_ec" sensors={selectedSensorsStr} strokecolor='#1A759F' fillcolor='#2C95C5' units='mS/m' factor={1} /> */}
              <PredictionAreaChart  query="mean_ec" sensors={selectedSensorsStr} strokecolor='#1A759F' fillcolor='#2C95C5' units='mS/m' factor={1} listaSensoresHistoricos={listaSensoresHistoricos}  />
              
            </CardBody>
            
            {/* <CardFooter chart style={{flexDirection:'column', padding:'2px', marginLeft:'1px', height:'100px'}}>
                
            </CardFooter> */}

          </Card>
        </GridItem>
     

        <GridItem xs={12} sm={12} md={12}>
          <Card>
          <CardHeader color="info" stats icon>
                <CardIcon color="info">
                  <ScienceIcon />
                </CardIcon>
                <p className={classes.cardCategory} style={{fontSize: '21px', marginTop:'5px'}}>{t.lN}&nbsp;</p>
                {/* <h2 className={classes.cardTitle} style={{fontSize: '25px', display:'inline'}}>
                  {ec_average} <small>mS/m</small>
                </h2> */}
              </CardHeader>
        
            <CardBody  style={{ padding:'3px', marginLeft:'3px', minHeight:'200px'}}>
              <PredictionAreaChart query="mean_n" sensors={selectedSensorsStr} strokecolor='#8884d8' fillcolor='#2C95C5' units='mS/m' factor={1} listaSensoresHistoricos={listaSensoresHistoricos} />
              
            </CardBody>
            
            {/* <CardFooter chart style={{flexDirection:'column', padding:'2px', marginLeft:'1px', height:'100px'}}>
                
            </CardFooter> */}

          </Card>
        </GridItem>
      

        <GridItem xs={12} sm={12} md={12}>
          <Card>
          <CardHeader color="info" stats icon>
                <CardIcon color="info">
                  <BiotechIcon />
                </CardIcon>
                <p className={classes.cardCategory} style={{fontSize: '21px', marginTop:'5px'}}>{t.lP}&nbsp;</p>
                {/* <h2 className={classes.cardTitle} style={{fontSize: '25px', display:'inline'}}>
                  {ec_average} <small>mS/m</small>
                </h2> */}
              </CardHeader>
        
            <CardBody  style={{ padding:'3px', marginLeft:'3px', minHeight:'200px'}}>
              <PredictionAreaChart  query="mean_p" sensors={selectedSensorsStr} strokecolor='#82ca9d' fillcolor='#2C95C5' units='mS/m' factor={1} listaSensoresHistoricos={listaSensoresHistoricos} />
              
            </CardBody>
            
            {/* <CardFooter chart style={{flexDirection:'column', padding:'2px', marginLeft:'1px', height:'100px'}}>
                
            </CardFooter> */}

          </Card>
        </GridItem>
    

        <GridItem xs={12} sm={12} md={12}>
          <Card>
          <CardHeader color="info" stats icon>
                <CardIcon color="info">
                  <FitbitIcon />
                </CardIcon>
                <p className={classes.cardCategory} style={{fontSize: '21px', marginTop:'5px'}}>{t.lK}&nbsp;</p>
                {/* <h2 className={classes.cardTitle} style={{fontSize: '25px', display:'inline'}}>
                  {ec_average} <small>mS/m</small>
                </h2> */}
              </CardHeader>
        
            <CardBody  style={{ padding:'3px', marginLeft:'3px', minHeight:'200px'}}>
              <PredictionAreaChart query="mean_k" sensors={selectedSensorsStr} strokecolor='#85cafd' fillcolor='#2C95C5' units='mS/m' factor={1} listaSensoresHistoricos={listaSensoresHistoricos} />
              
            </CardBody>
            
            {/* <CardFooter chart style={{flexDirection:'column', padding:'2px', marginLeft:'1px', height:'100px'}}>
                
            </CardFooter> */}

          </Card>
        </GridItem>
      

       
      

        <GridItem xs={12} sm={12} md={12}>
          <Card>
          <CardHeader color="info" stats icon>
                <CardIcon color="info">
                  <BoltIcon />
                </CardIcon>
                <p className={classes.cardCategory} style={{fontSize: '21px', display:'inline'}}>{t.lBattery} &nbsp;</p>
                <h2 className={classes.cardTitle} style={{fontSize: '25px', display:'inline'}}>
                {voltage_average} <small>V.</small>
                </h2>
              </CardHeader>
        
            <CardBody  style={{ padding:'3px', marginLeft:'3px', minHeight:'200px'}}>
              {/* <CustomAreaChart start={startDate} stop={endDate} query="mean_voltage" sensors={selectedSensorsStr} strokecolor='#1A759F' fillcolor='#2C95C5' units='V' factor={1} /> */}
              <PredictionAreaChart  query="mean_voltage" sensors={selectedSensorsStr} strokecolor='#1A759F' fillcolor='#2C95C5' units='V' factor={1} listaSensoresHistoricos={listaSensoresHistoricos} />
           
            </CardBody>
            
            {/* <CardFooter chart style={{flexDirection:'column', padding:'2px', marginLeft:'1px', height:'100px'}}>
                
            </CardFooter> */}

          </Card>
        </GridItem>
     

    </GridContainer>
  </>
  );
}
